import css from 'styled-jsx/css';

const staticStyles = css.global`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  .WithdrawApprovalListTable {
    /* Block flow: the email row and the tag row stack, the tag always keeps its own line */
    .WithdrawApprovalListTable__emailCell {
      display: block;
      min-width: 0;
      max-width: 100%;
    }

    .WithdrawApprovalListTable__email {
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      min-width: 0;
      max-width: 100%;
    }

    .WithdrawApprovalListTable__bonusAbuserTag {
      display: inline-block;
      /* Same chip style as BOUsersTable__BonusAbuserTag; larger top gap because
         the email above carries an underline that sits flush at its box bottom */
      margin-top: 8px;
      padding: 2px 8px;
      border: 1px solid #ef9a9a;
      border-radius: 4px;
      background-color: #fdecea;
      color: #c62828;
      font-size: 12px;
      line-height: 16px;
      white-space: nowrap;
    }

    :global(.ReactDataTable) {
      tr {
        grid-template-columns: repeat(3, minmax(100px, 2fr)) repeat(3, minmax(100px, 1fr)) minmax(20px, 0.5fr);

        .ReactDataTable__tbody-cell {
          .time {
            display: block;
          }
        }
      }
    }

    .ResponsiveTable__thead {
      min-width: 400px;

      span {
        &:nth-of-type(2) {
          @include respond-to(sm) {
            text-align: left;
            padding: 5px 0 5px 15px;
          }
        }
      }
    }

    .ResponsiveTable__tbody {
      min-width: 400px !important;
    }

    .ResponsiveTable__row-item {
      &:nth-of-type(2) {
        @include respond-to(sm) {
          overflow: hidden;
          justify-content: flex-start !important;
        }
      }
    }
  }
`;

const getDynamicStyles = ({ colors }) => {
  return css.global`
    .WithdrawApprovalListTable {
      :global(.ReactDataTable) {
        tr {
          .ReactDataTable__tbody-cell {
            .time {
              color: ${colors.gray.hex};
            }
          }
        }
      }
    }
  `;
};

export { staticStyles, getDynamicStyles };
